<template>
  <div id="popup" class="bsfz-popup">
    <div class="bsfz-popup__content">
      <div class="bsfz-popup__header">
        <h2>{{ header }}</h2>
      </div>
      <div class="bsfz-popup__content__slot">
        <slot name="content" {{ text }} />
      </div>
      <div class="bsfz-popup__action__slot">
        <slot name="action">
          <v-row>
            <v-col>
              <slot name="abort-btn">
                <b-btn class="mr-2" color="grey" @click="abort" block>
                  <slot name="abort-btn-label">Abbrechen</slot>
                </b-btn>
              </slot>
            </v-col>
            <v-col>
              <slot name="accept-btn">
                <b-btn @click="accept" :disabled="isAcceptButtonDisabled" block>
                  <slot name="accept-btn-label">Übernehmen</slot>
                </b-btn>
              </slot>
            </v-col>
          </v-row>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    header: { type: String, required: true },
    isAcceptButtonDisabled: Boolean,
    hideSaveButton: Boolean
  },
  methods: {
    abort() {
      this.$emit('abort');
    },
    accept() {
      this.$emit('accept');
    }
  }
};
</script>

<style lang="scss">
.bsfz-popup {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;

  &__content {
    background-color: white;
    border-radius: 5px;
    margin: auto;
    width: 50%;
    max-height: 80%;
    padding: 15px;
    overflow-y: scroll;

    .bsfz-popup__header,
    .bsfz-popup__content__slot {
      padding-bottom: 15px;
    }

    .bsfz-popup__action__slot {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      padding-top: 15px;
    }
  }
}

@media screen and (max-width: 600px) {
  .bsfz-popup {
    &__content {
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>
